import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['PageHeader-cvaRoot'], {
  variants: {
    pt: {
      small: ['pt-1.6 sm:pt-2.4 '],
      large: ['pt-1.6 sm:pt-6.7 '],
      none: ['pt-0'],
    },
    pb: {
      small: ['pb-2.4 sm:pb-2.4'],
      large: ['pb-2.4 sm:pb-4.8'],
      none: ['pb-0'],
    },
  },
  defaultVariants: {
    pt: 'small',
    pb: 'large',
  },
});
